import axios from 'axios';

import { API_URL } from './settings';

axios.interceptors.request.use(
	config => {
		if (!config.headers.Authorization && typeof localStorage !== "undefined") {
			const token = localStorage.getItem('token');
			if (token) {
				config.headers['Authorization'] = `Bearer ${token}`;
			}
		}

		return config;
	},
	error => {
		Promise.reject(error)
	}
);

axios.interceptors.response.use(
	response => {
		return response;
	}, error => {
		if (error.response.status === 401 || error.response.status === 403) {
			localStorage.removeItem('token');
		}
	}
);

export const search = async (terms) => {
	// TODO: add search live for ER?
	// const response = await axios.get(`${API_URL}/search/live?q=${terms}`);
	const response = await axios.get(`${API_URL}/events?q=${terms}&page_size=5`);
	const results = { events: { name: 'Events', results: response.data?.results.map(item => ({ id: item.id, title: item.title, url: `/events/${item.id}` })) } };
	return results;
}

export const fetchAdminDashboardStats = async () => {
	const response = await axios.get(`${API_URL}/dashboard/stats`);
	return await response?.data;
}

/* Account */
export const getAccount = async () => {
	const response = await axios.get(`${API_URL}/account`);
	return await response.data;
};

export const updateAccount = async (data) => {
	const response = await axios.put(`${API_URL}/account`, data);
	return await response.data;
};

export const forgotPassword = async (data) => {
	const response = await axios.post(`${API_URL}/account/forget_password`, data);
	return await response.data;
};

export const resetPassword = async (data) => {
	const response = await axios.post(`${API_URL}/account/reset_password`, data);
	return await response.data;
};

/* Users */
export const sendForgotPassword = async (id) => {
	const response = await axios.post(`${API_URL}/users/${id}/forget_password`);
	return await response.data;
};

/* Events */
export const requestReviewEvent = async (id) => {
	const response = await axios.post(`${API_URL}/events/${id}/request_review`);
	return response.data;
};

export const publishEvent = async (id) => {
	const response = await axios.post(`${API_URL}/events/${id}/publish`);
	return response.data;
};

export const unpublishEvent = async (id) => {
	const response = await axios.post(`${API_URL}/events/${id}/unpublish`);
	return response.data;
};

/* Messages */
export const fetchMessages = async () => {
	const response = await axios.get(`${API_URL}/messages`);
	return await response.data;
}